export default {
  getSolicitacoesProcesso(state) {
    return state.solicitacoesProcesso.map((solicitacaoProcesso) => ({
      ...solicitacaoProcesso,
      referenciaTrust: solicitacaoProcesso.referenciaTrust || '-',
      situacaoSolicitacao: '0',
    }));
  },
  getSolicitacaoProcesso(state) {
    return state.solicitacaoProcesso;
  },
  getStatusSolicitacaoProcesso(state) {
    return state.statusSolicitacaoProcesso;
  },
  getTiposProcesso(state) {
    return state.tiposProcesso;
  },
  getTotalProcessos(state, getters) {
    return getters.getSolicitacoesProcesso.length;
  },
  getTiposDocumento(state) {
    return state.tiposDocumento;
  },
  getAbrirModal(state) {
    return state.abrirModal;
  },
  getAbrirModalVisualizacao(state) {
    return state.abrirModalVisualizacao;
  },
  getAbrirModalOrdemCompra(state) {
    return state.abrirModalOrdemCompra;
  },
  getColunasItensProcesso(state) {
    return state.colunasItensProcesso;
  },
  getColunasItensProcessoPDF(state) {
    return state.colunasItensProcessoPDF;
  },
  getColunasItensCotacao(state) {
    return state.colunasItensCotacao;
  },
  getLinkSolicitacaoProcesso(state) {
    // eslint-disable-next-line no-underscore-dangle
    const id = state?.solicitacaoProcesso?._id;
    if (!id) {
      return '';
    }
    const URL_BASE = process.env.VUE_APP_FRONTEND_HOST_PORT;
    return `${URL_BASE}/processos/solicitacao?_id=${id}`;
  },
  getExportadores(state) {
    return state.exportadores;
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
  getModeloOrdemCompra(state) {
    return state.modeloOrdemCompra;
  },
  getDownloadOrdem(state) {
    return state.downloadOrdem;
  },
  getDownloadProcesso(state) {
    return state.downloadProcesso;
  },
  getRascunhos(state) {
    return Object.values(state.rascunhos);
  },
};
